import Vue from 'vue'
import VueRouter from 'vue-router'
import Head from '@/views/homePage/index.vue'

/* const originPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
	return originPush.call(this, location).catch(err => err)
} */
Vue.use(VueRouter)

const _import = require('./import-' + process.env.NODE_ENV)

const routes = [
	{path: '/',name: 'Head',component: Head, meta: {title: '首页', requireAuth:true}},
	{path: '/order', component: _import('order/order'), name: 'order', meta: {title: '订单中心', isTab: true, requireAuth:true}},
	{path: '/shoppingCar', component: _import('shoppingCar/index'), name: 'index', meta: {title: '购物车', requireAuth:true}},
	{path: '/empty', component: _import('register/empty'), name: 'empty', meta: {title: '页面跳转'}},
	{path: '/orderDetails', component: _import('order/orderDetails'), name: 'orderDetails', meta: {title: '订单详情', requireAuth:true}},
	{path: '/refundDetails', component: _import('order/refundDetails'), name: 'refundDetails', meta: {title: '退款详情', requireAuth:true}},
	{path: '/chooseType', component: _import('order/chooseType'), name: 'chooseType', meta: {title: '售后申请', requireAuth:true}},
	{path: '/refundOrder', component: _import('order/refundOrder'), name: 'refundOrder', meta: {title: '退款/售后', requireAuth:true}},
	{path: '/refundModify', component: _import('order/refundModify'), name: 'refundModify', meta: {title: '售后申请修改', requireAuth:true}},
	{path: '/kefu', component: _import('order/kefu'), name: 'kefu', meta: {title: '客服介入', requireAuth:true}},
	{path: '/payment', component: _import('homePage/payment'), name: 'payment', meta: {title: '支付订单', requireAuth:true}},
	{path: '/pintuangouDet', component: _import('homePage/pintuangouDet'), name: 'pintuangouDet', meta: {title: '商品详情', requireAuth:true}},
	{path: '/productList', component: _import('homePage/productList'), name: 'productList', meta: {title: '商品列表', requireAuth:true}},
	{path: '/placeOrder', component: _import('homePage/placeOrder'), name: 'placeOrder', meta: {title: '提交订单', requireAuth:true}},
	{path: '/register', component: _import('register/register'), name: 'register', meta: {title: '注册'}},
	{path: '/login', component: _import('login/login'), name: 'login', meta: {title: '登录'}},
	{path: '/findPsw', component: _import('login/findPsw'), name: 'findPsw', meta: {title: '找回密码'}},
	{path: '/addInfo', component: _import('login/addInfo'), name: 'addInfo', meta: {title: '完善资质信息', requireAuth:true}},
	{path: '/xieyi', component: _import('register/xieyi'), name: 'xieyi', meta: {title: '用户协议'}},
	{path: '/yinsi', component: _import('register/yinsi'), name: 'yinsi', meta: {title: '隐私政策'}},
	{path: '/shopCartOrder', component: _import('shoppingCar/shopCartOrder'), name: 'shopCartOrder', meta: {title: '提交订单', requireAuth:true}},
	/* {path: '/vueMchat', component: _import('homePage/vueMchat'), name: 'vueMchat', meta: {title: '交流', requireAuth:true}}, */
	{path: '/goodsDet', component: _import('homePage/goodsDet'), name: 'goodsDet', meta: {title: '商品详情', requireAuth:true}},
	{path: '/dianpu', component: _import('homePage/dianpu'), name: 'dianpu', meta: {title: '店铺', requireAuth:true}},
	{path: '/helpCenterList', component: _import('helpCenter/helpCenterList'), name:'centers', meta: {title: '帮助中心', requireAuth:false}},
	{path: '/helpCenterDet', component: _import('helpCenter/helpCenterDet'), name:'det', meta: {title: '文章详情', requireAuth:false}}
]

export default new VueRouter({
	routes
})



// WEBPACK FOOTER //
// ./src/router/index.js